<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row>
			<b-col md="12">
				<b-card>
					<template v-slot:header>
						<b-row class="align-items-center">
							<b-col md="6">
								<strong>Zonificación</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>

								<div v-if="!loading && zoningList && zoningList.length > 0" class="ml-2">
									<b-button variant="link"
											  class="text-success"
											  @click="exportToExcel"
											  v-b-tooltip.hover title="Descargar listado en Formato Excel">
										<i class="fa fa-file-excel-o fa-2x" aria-hidden="true"></i>
									</b-button>
								</div>
							</b-col>
						</b-row>
					</template>

					<b-card-body class="table-responsive">
						<b-row class="justify-content-between">
							<b-col md="12">
								<b-form-group>
									<label class="m-0"><strong class="text-black-50">Buscar:</strong></label>
									<b-input v-model="filter" type="search"></b-input>
								</b-form-group>
							</b-col>
						</b-row>
						<b-table :items="zoningList"
								 :fields="zoningTableFields"
								 :busy="loading"
								 :current-page="currentPage"
								 :per-page="perPage"
								 :filter="filter"
								 :filter-included-fields="filterOn"
								 show-empty
								 striped
								 empty-filtered-text="No hay zonificación disponibles"
								 empty-text="No hay zonificación disponibles"
								 head-variant="light"
								 @filtered="onFiltered">
							<div slot="CreatedOn" slot-scope="item">
								{{item.item.CreatedOn | dateFormatFull}}
							</div>
							<template v-slot:table-busy>
								<div class="text-center text-info my-2">
									<b-spinner class="align-middle"></b-spinner>
								</div>
							</template>
						</b-table>
						<nav class="d-flex justify-content-center" v-if="totalRows > perPage">
							<b-pagination
								:total-rows="totalRows"
								:per-page="perPage"
								v-model="currentPage"
								prev-text="<<"
								next-text=">>"
								hide-goto-end-buttons/>
						</nav>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
	import AccountDetailComponent from "../components/AccountDetailComponent";
	import GoBackComponent from "../components/GoBackComponent";
	import {mapActions, mapState} from "vuex";
	import XLSX from "xlsx";

	export default {
		name: "ZoningList",
		components: {
			AccountDetailComponent,
			GoBackComponent
		},
		data: function () {
			return {
				perPage: 10,
				currentPage: 1,
				loading: false,
				zoningList: [],
				filter: '',
				filterOn: [],
				totalRows: 1,
				zoningTableFields: {
					Link: {
						label: 'Lazo'
					},
					Zone: {
						label: 'Zona'
					},
					IPAddress: {
						label: 'IP'
					},
					Model: {
						label: 'Modelo'
					},
					Product: {
						label: "Producto"
					},
					SerialNumber: {
						label: '# Serie'
					},
					Location: {
						label: 'Ubicación'
					}
				},
			}
		},
		mounted() {
			if (this.accountSelected !== '') {
				this.loading = true;

				this.getZoningList()
					.then((zoning) => {
						this.zoningList = zoning;
						this.totalRows = this.zoningList.length;
					})
					.catch((err) => {
						console.error(err.response);
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					})

			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			...mapActions([
				'getZoningList',
			]),
			exportToExcel() {
				let newList = this.zoningList.map(function (obj) {
					return {
						'Zona': obj.Zone,
						'Modelo': obj.Model,
						'Producto': obj.Product,
						'Serie': obj.SerialNumber,
						'Ubicación': obj.Location
					};
				});

				let data = XLSX.utils.json_to_sheet(newList);
				const workbook = XLSX.utils.book_new();
				const filename = 'zonificacion';
				XLSX.utils.book_append_sheet(workbook, data, filename);
				XLSX.writeFile(workbook, `${filename}.xlsx`);
			},
			onFiltered(filteredItems) {
				this.totalRows = filteredItems.length;
				this.currentPage = 1
			}
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected,
			})
		}
	}
</script>

<style scoped>

</style>
